export const mockData = [
    {
        key: '1',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '2',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivering',
    },
    {
        key: '3',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '4',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '5',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '6',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '7',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '8',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '9',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '10',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '11',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '12',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '13',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
    {
        key: '14',
        orderCode: '230725321',
        date: 'Nov 24, 2020',
        products: 'Letraset sheets containing Lorem Ipsum passages...',
        amount: 2300,
        status: 'Delivered',
    },
];
